export const environment = {
  production: false,
  apiUrl: 'https://usedpsi05fwap02.azurewebsites.net/api/',
  Url: 'https://usedpsi05faca01.agreeablewater-adcb59c9.eastus.azurecontainerapps.io/api/',
  _appKey: 'KfsfBcYmIkAEk1Mxw0NZ4kKw618CmhsGHSPS6YUW',
  instrumentationKey:
    'InstrumentationKey=da1c9c52-2523-492b-a7f4-783743cafc41;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/',
  genUrl:
    'https://usedpsi05faca01.agreeablewater-adcb59c9.eastus.azurecontainerapps.io/',
  genSocketUrl:
    'wss://usedpsi05faca01.agreeablewater-adcb59c9.eastus.azurecontainerapps.io/ws',
};
